import type { AxiosApiResponsePromise } from "~/api/apiResponseTypes.ts";
import axiosApi from "~/api/axiosApi.ts";
import { staffMembersSickDaysEndpoint } from "~/modules/absence/api/sickDay/sickDayApiEndpoints.ts";
import type { SickDays } from "~/modules/absence/api/sickDay/sickDayTypes.ts";

export function getStaffMembersSickDaysByYear({ staffMemberId, year }: {
	staffMemberId: string,
	year: number
}): AxiosApiResponsePromise<SickDays> {
	return axiosApi.get(staffMembersSickDaysEndpoint(staffMemberId, year));
}
